import { QueryClient } from '@tanstack/react-query';
import { AccessDeniedError, ApiError } from './client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // An access state and a 4xx are answers, not outages. Retrying them
        // delays the screen that explains what happened.
        if (error instanceof AccessDeniedError) {
          return false;
        }
        if (error instanceof ApiError && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      }
    },
    mutations: { retry: false }
  }
});
